<div [class]="'progress-bar progress-container '+class" *ngIf="mode == 'determinate' && loading">
  <div class="progress-bar-inner" [style.width.%]="value">
  </div>
</div>
<div [class]="'progress-container '+class" *ngIf="mode == 'indeterminate' && loading">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
<div class="progress-container" *ngIf="!loading"></div>